export const PACKAGE_NAME = 'jiraNavigationAppsSidebarNav4GlobalAppShortcuts';
export const TEAM_NAME = 'jira-cosmos';
